import { useEffect, useState } from 'react';
import Lottie from 'react-lottie';
import * as animationData from './images/loader.json';

const defaultOptions = {
  loop: true,  // Keep loop as true to continuously play the animation
  autoplay: true, 
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

const Loader = () => {

  return (
    <div className="flex justify-center bg-banner items-center h-screen overflow-hidden">
      <Lottie 
        options={defaultOptions}
        height={200}
        width={200}
      />
    </div>
  );
};

export default Loader;
